import { registerEnum } from '@cbbt/lib-interface';
var IdvStatus;
(function (IdvStatus) {
    IdvStatus["AUTO_CHECK_FAILED"] = "AUTO_CHECK_FAILED";
    IdvStatus["INITIAL"] = "INITIAL";
    IdvStatus["ON_HOLD"] = "ON_HOLD";
    IdvStatus["OPEN"] = "OPEN";
    IdvStatus["PENDING_MANUAL_SUBMISSION"] = "PENDING_MANUAL_SUBMISSION";
    IdvStatus["PENDING_TO_BE_RETRIEVED"] = "PENDING_TO_BE_RETRIEVED";
    IdvStatus["RESPONSE_AVAILABLE"] = "RESPONSE_AVAILABLE";
    IdvStatus["RESPONSE_PROCESSED"] = "RESPONSE_PROCESSED";
    IdvStatus["SUBMITTED_TO_VENDOR"] = "SUBMITTED_TO_VENDOR";
    IdvStatus["TRIES_EXCEEDED"] = "TRIES_EXCEEDED";
    IdvStatus["UPLOADED"] = "UPLOADED";
    IdvStatus["VENDOR_RESPONSE_RECEIVED"] = "VENDOR_RESPONSE_RECEIVED";
})(IdvStatus || (IdvStatus = {}));
registerEnum(IdvStatus, 'IdvStatus');
export { IdvStatus };
//# sourceMappingURL=IdvStatus.js.map